import { render, staticRenderFns } from "./LoFOverTime.vue?vue&type=template&id=136d8cc6&"
import script from "./LoFOverTime.vue?vue&type=script&lang=js&"
export * from "./LoFOverTime.vue?vue&type=script&lang=js&"
import style0 from "./LoFOverTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports